import { axiosInstance } from '../../utils/utilsAxiosExternal';

export async function getPaymentToken(site, accountNumber, routingNumber) {
  const url = process.env.REACT_APP_CARD_POINTE_TOKENIZE_API_URL.replace('{{site}}', site);

  try {
    const data = { account: `${routingNumber}/${accountNumber}` };
    const response = await axiosInstance.post(url, data);
    return response.data.token;
  } catch (error) {
    throw new Error(error);
  }
}
